module.exports = __webpack_public_path__ + "media/images/linkedin-2aeca8500d94b3676d67d32e68edc33d.png";